import {Auth} from 'aws-amplify';

// See https://github.com/aws/aws-amplify/blob/master/packages/aws-amplify-react-native/src/Auth/Authenticator.js
class AuthService {
  checkAuthentication() {
    return Auth.currentAuthenticatedUser()
      .then(user => {
        // console.log('=== checkAuthentication called. logged in');
        return {isAuthenticated: true, user};
      })
      .catch(error => {
        console.log(error);

        return {isAuthenticated: false};
      });
  }

  getUser() {
    return Auth.currentAuthenticatedUser();
  }
}

export default new AuthService();
